import {
  API_URL,
  SagaIterator,
  assertTotalSchema,
  call,
  createDoRequestAction,
  debug,
  put,
  request,
  takeEvery,
  v,
} from '../../lib'
import {
  doBATCH_PARTICIPANT_TAG_LIST_UPDATE,
  doPROJECT_TAG_LIST_SET,
  doREQUEST_COMPLETE,
  doREQUEST_ERROR,
} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PROJECT_TAG_LIST_FETCH = 'REQUEST_PROJECT_TAG_LIST_FETCH'
export const doREQUEST_PROJECT_TAG_LIST_FETCH = createDoRequestAction(REQUEST_PROJECT_TAG_LIST_FETCH)

export const requestProjectTagListFetchActionCreators = {
  doREQUEST_PROJECT_TAG_LIST_FETCH,
}

export function* requestProjectTagListFetch({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestProjectTagListFetch')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_TAG_LIST_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {projectId} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'POST',
    url: `${API_URL}/v1/web/project-tag-list-fetch`,
    accessToken,
    data: {
      projectId,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_TAG_LIST_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/project-tag-list-fetch',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doPROJECT_TAG_LIST_SET({
      id: projectId,
      tagList: result.payload,
    }),
  )

  yield put(
    doBATCH_PARTICIPANT_TAG_LIST_UPDATE({
      projectId,
      tags: result.payload,
    }),
  )

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_TAG_LIST_FETCH,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* projectTagListFetchSaga() {
  yield takeEvery(REQUEST_PROJECT_TAG_LIST_FETCH, requestProjectTagListFetch)
}
